import React, { Component } from 'react';
import firebase from '../helpers/firebase';
import Button from '@material-ui/core/Button';
import styles from './NewPost.module.css';
import TextField from '@material-ui/core/TextField';
import ImageUploader from 'react-images-upload';
import { ThemeProvider } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { Helmet } from 'react-helmet';
import NetworkToolbar from './NetworkToolbar';
import { darkTheme } from './darkTheme';

export default class NewPost extends Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.state = {
      name: '',
      email: '',
      zip_code: '',
      post_title: '',
      post_description: '',
      type: '',
      category: '',
      pictures: [],
      searchValue: '',
      disabled: false,
    };
  }

  handleChangeEmail = (event) => {
    this.setState({ email: event.target.value });
  };
  handleChangeName = (event) => {
    this.setState({ name: event.target.value });
  };
  handleChangeZipCode = (event) => {
    let value = event.target.value.replace(/[^0-9]/g, '');
    this.setState({ zip_code: value });
  };
  handleChangePostTitle = (event) => {
    this.setState({ post_title: event.target.value });
  };
  handleChangePost = (event) => {
    this.setState({ post_description: event.target.value });
  };
  handleChangeType = (event) => {
    this.setState({ type: event.target.value });
  };
  handleChangeCategory = (event) => {
    this.setState({ category: event.target.value });
  };

  uuidv4() {
    let sGuid = '';
    for (let i = 0; i < 32; i++) {
      sGuid += Math.floor(Math.random() * 0xf).toString(0xf);
    }
    return sGuid;
  }

  onDrop(picture) {
    this.setState({
      pictures: this.state.pictures.concat(picture),
    });
  }

  post = async () => {
    if (
      this.state.name !== '' &&
      this.state.email !== '' &&
      this.state.zip_code !== '' &&
      this.state.post_title !== '' &&
      this.state.type !== '' &&
      this.state.category !== '' &&
      this.state.post_description !== '' &&
      this.state.pictures.length !== 0
    ) {
      this.setState({ disabled: true });
      alert('Your post will be approved soon!');
      let imgName = this.uuidv4() + this.state.pictures[0].name.split('.')[1];
      const postsCollection = await firebase
        .firestore()
        .collection('network')
        .doc('posts')
        .collection('posts');
      const storageRef = await firebase
        .storage()
        .ref('networkImages/' + imgName);

      postsCollection
        .doc()
        .set({
          name: this.state.name,
          email: this.state.email,
          zip_code: this.state.zip_code,
          post_title: this.state.post_title,
          post_description: this.state.post_description,
          date: new Date(),
          image: imgName,
          active: false,
          type: this.state.type,
          category: this.state.category,
        })
        .then(() => {
          storageRef
            .put(this.state.pictures[0])
            .then(() => {
              window.location.href = 'https://de-waste.com/network';
            })
            .catch(function (error) {
              console.error('Error: ', error);
            });
        })
        .catch(function (error) {
          console.error('Error: ', error);
        });
    } else {
      alert('Please fill out all fields!');
    }
  };

  checkEnter = (event) => {
    if (event.keyCode === 13) {
      localStorage.setItem('searchValue', this.state.searchValue);
      window.location.href = 'https://de-waste.com/network';
    }
  };

  handleChangeSearchValue = (event) => {
    this.setState({ searchValue: event.target.value });
  };

  render() {
    return (
      <ThemeProvider theme={darkTheme}>
        <div>
          <Helmet>
            <meta
              name="description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others"
            />

            <meta
              itemProp="name"
              content="DeWaste Network | Connecting food producers and buyers to reduce food waste"
            />
            <meta
              itemProp="description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others in their proximity and trade in these food items so they don't go to waste."
            />
            <meta
              itemProp="image"
              content="https://de-waste.com/network_logo.png"
            />

            <meta
              property="og:image"
              content="https://de-waste.com/network_logo.png"
            />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="DeWaste Network" />
            <meta
              property="og:description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others."
            />
            <meta property="og:site_name" content="DeWaste" />
            <meta property="og:url" content="https://de-waste.com/network" />

            <meta name="twitter:card" content="summary" />
            <meta
              name="twitter:image"
              content="https://de-waste.com/network_logo.png"
            />
            <meta name="twitter:title" content="DeWaste Network" />
            <meta
              name="twitter:description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others."
            />

            <title>
              DeWaste Network | Connecting food producers and buyers
            </title>
          </Helmet>

          <NetworkToolbar
            handleChangeSearchValue={this.handleChangeSearchValue}
            searchValue={this.state.searchValue}
            checkEnter={this.checkEnter}
          />

          <div className={styles.placeholder} />
          <div className={styles.placeholder} />
          <div className={styles.placeholder} />
          <div className={styles.placeholder} />

          <div className={styles.formContainerDiv}>
            <h1 className={styles.mainText}>Make a new post</h1>
            <hr className={styles.hr} />
            <br />

            <form noValidate autoComplete="off">
              <TextField
                label="Name"
                onChange={this.handleChangeName}
                variant="outlined"
                className={styles.formField}
              />
              <br />
              <br />
              <TextField
                label="Email (This will be public)"
                onChange={this.handleChangeEmail}
                variant="outlined"
                className={styles.formField}
              />
              <br />
              <br />
              <TextField
                label="Zip Code"
                onChange={this.handleChangeZipCode}
                value={this.state.zip_code}
                variant="outlined"
                className={styles.formField}
              />
              <br />
              <br />
              <FormControl
                className={styles.formField}
                style={{ textAlign: 'left' }}
              >
                <InputLabel>Type of Post</InputLabel>
                <Select
                  value={this.state.type}
                  onChange={this.handleChangeType}
                >
                  <MenuItem value={'sell'}>Selling Something</MenuItem>
                  <MenuItem value={'buy'}>Buying Something</MenuItem>
                </Select>
              </FormControl>
              <br />
              <br />
              <FormControl
                className={styles.formField}
                style={{ textAlign: 'left' }}
              >
                <InputLabel>Category</InputLabel>
                <Select
                  value={this.state.category}
                  onChange={this.handleChangeCategory}
                >
                  <MenuItem value={'fruits'}>Fruits</MenuItem>
                  <MenuItem value={'vegetables'}>Vegetables</MenuItem>
                  <MenuItem value={'meat'}>Meat</MenuItem>
                  <MenuItem value={'other'}>Other</MenuItem>
                </Select>
              </FormControl>
              <br />
              <br />
              <TextField
                label="Post Title"
                onChange={this.handleChangePostTitle}
                variant="outlined"
                className={styles.formField}
              />
              <br />
              <br />
              <TextField
                id="outlined-multiline-static"
                variant="outlined"
                label="Post Description"
                multiline
                rows={4}
                onChange={this.handleChangePost}
                className={styles.formField}
              />
              <br />
              <br />
              <ImageUploader
                withIcon={true}
                withPreview={true}
                buttonText="Choose Image"
                onChange={this.onDrop}
                imgExtension={['.jpg', '.gif', '.png', '.gif']}
                maxFileSize={5242880}
                withLabel={true}
                singleImage={true}
              />
              <Button
                onClick={this.post}
                variant={'contained'}
                color="primary"
                className={styles.signInButton}
                disabled={this.state.disabled}
              >
                Post
              </Button>
            </form>
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      </ThemeProvider>
    );
  }
}
